import Navbar from "./components/NavBar";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  HashRouter,
} from "react-router-dom";
import Insight from "./pages/Insight";
import Stats from "./pages/Stats";
import Home from "./pages/Home";
 
import Footer from "./components/HomeComponents/Footer";
import Contact from "./components/HomeComponents/Contact";
import Data from "./components/Data";
import PrivateRoute from "./routing/PrivateRoute";
import { setUser } from "./actions/auth";
import Auth from "./components/Auth/Auth";
import { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./store";
import { useState } from "react";
 
export default function App() {
  useEffect(() => {
    if (localStorage.token) store.dispatch(setUser(localStorage.token));
  }, []);

  return (
    <Provider store={store}>
      <div className="App">
        <Navbar />
        <Routes>
          <Route
            path="/:type/:id/:year"
            element={
              <PrivateRoute>
                <Data />
              </PrivateRoute>
            }
          />

          <Route path="/" exact element={<Home />} />
          <Route
            path="/insight"
            element={
              <PrivateRoute>
                <Insight />
              </PrivateRoute>
            }
          />

          <Route path="/auth" exact element={<Auth />} />
         
          <Route path="/stats" exact element={<Stats />}></Route>
          <Route
            path="*"
            exact
            element={
              <>
                <div
                  style={{
                    margin: "2rem auto",
                    textAlign: "center",
                    fontSize: "2.5rem",
                    color: "rgba(138, 94, 191, 1) ",
                  }}
                >
                  Not Found 😔
                </div>
              </>
            }
          ></Route>
        </Routes>
        <Contact />
        <Footer />
      </div>
    </Provider>
  );
}